import {clearGlobalError} from "modules/actions/errors";
import {getErrorsStore} from "modules/selectors/errors";
import React, {useCallback, useEffect, useRef} from "react";
import {useDispatch, useSelector} from "react-redux";
import styled from "@emotion/styled";

const FixedPlace = styled.div`
	@keyframes close {
		from {
			transform: translateY(0);
		}
		to {
			transform: translateY(-100%);
		}
	}

	position: fixed;
	left: 0;
	top: 0;
	display: flex;
	align-items: flex-start;
	justify-content: center;
	background: rgb(9 11 15 / 55%);
	width: 100%;
	height: 100%;
	z-index: 999;

	div {
		padding: 30px 20px;
		color: #fff;
		font-size: 18px;
		border-radius: 0 0 20px 20px;
		max-width: 100%;
		font-weight: bold;
		text-align: center;
		width: 100%;
		background: #ff583e;
		transform: translateY(0);

		&.closing {
			animation: close 0.3s ease forwards;
		}
	}
`;
export const ErrorMessage: React.FC = () => {
	const dispatch = useDispatch();

	const error = useSelector(getErrorsStore);
	const isOpen = Boolean(error.message);
	const animationRef = useRef<HTMLDivElement>(null);

	let timeout: ReturnType<typeof setTimeout>;

	const onClose = useCallback(() => {
		clearTimeout(timeout);

		const animationElement = animationRef.current;

		if (animationElement) {
			animationElement.addEventListener("animationend", () => {
				dispatch(clearGlobalError());
			});

			animationElement.classList.add("closing");
		}
	}, []);

	useEffect(() => {
		timeout = setTimeout(() => {
			onClose();
		}, 5000);

		return () => {
			clearTimeout(timeout);
		};
	}, [isOpen, onClose]);

	return isOpen ? (
		<FixedPlace onClick={onClose}>
			<div ref={animationRef} role="alert" aria-relevant="all">
				{error.message}
			</div>
		</FixedPlace>
	) : null;
};
